import React from "react";

/**
 * Real team data drawn from peiarchitect.com/team
 */
const TEAM = [
  {
    name: "Lorin Brehaut",
    role: "Founder & Architect",
    creds: "BEDS, MArch · AAPEI, MRAIC",
    bio:
      "Lorin graduated from Dalhousie University with a Master of Architecture in 1990. For much of his professional career, he worked in New York, Bermuda, and Massachusetts before returning home to Prince Edward Island in 2010 to establish studio Brehaut architecture. Inspired by the rural land and seascapes, Lorin blends sustainable design, intuitive spatial planning, and gracious proportions with undeniable Maritime character.",
  },
  {
    name: "Marwa El-Zawahry",
    role: "Graduate Architect",
    creds: "Faculty of Engineering, Cairo University",
    bio:
      "Marwa graduated from the Faculty of Engineering at Cairo University with an honours degree in architecture in 2017, driven by a passion for transforming challenges into innovative solutions. With more than seven years of architectural experience across the Middle East, she is now based in PEI to explore and learn from the island’s unique architectural character.",
  },
  {
    name: "You-Jen Chen",
    role: "Architectural Technologist",
    creds: "MSc Building & Planning",
    bio:
      "You-Jen holds a Master of Science in Building and Planning and has several years of experience as a planner and designer in Taiwan — including community development, people-oriented transportation improvement, religious architecture, and aging-in-place design. In 2024, You-Jen became an Architectural Technologist in Canada.",
  },
  {
    name: "Mark Sider",
    role: "Graduate Architect",
    creds: "University of Waterloo",
    bio:
      "Mark is a graduate of the School of Architecture, University of Waterloo. Much of his professional career has been spent in Toronto and Ottawa, focusing on public buildings — sports, recreation, and leisure facilities. Mark currently represents Studio Brehaut on the Ministry of Veterans Affairs, Daniel J. MacDonald Modernization Project as Resident Construction Services, based in Charlottetown.",
  },
];

export const Team = () => {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="py-28 md:py-40 relative"
    >
      <div
        aria-hidden
        className="absolute left-0 right-0 top-0 h-[1px]"
        style={{ backgroundColor: "rgba(200,184,154,0.22)" }}
      />
      <div className="container-editorial">
        <div className="reveal mb-16 md:mb-24 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p
              className="text-[11px] uppercase font-body mb-6"
              style={{ color: "#3a7d7b", letterSpacing: "0.36em" }}
            >
              — Our Team
            </p>
            <h2
              className="font-display leading-[1.02] tracking-[-0.018em]"
              style={{ fontSize: "clamp(2.25rem, 5vw, 4.75rem)", fontWeight: 400 }}
            >
              A small team, united by <em className="italic">purposeful work</em>.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7">
            <p
              className="font-body text-base md:text-[17px] leading-[1.85] max-w-lg mt-4 md:mt-12"
              style={{ color: "hsl(var(--foreground) / 0.8)" }}
            >
              We are united by a love for purposeful work, thoughtful design, and real
              connection — with our clients, with the trades, and with the land on which we
              build. A selection of the people behind the drawings.
            </p>
          </div>
        </div>

        <ul className="divide-y divide-foreground/15">
          {TEAM.map((m, i) => (
            <li
              key={m.name}
              data-testid={`team-member-${m.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="reveal grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 py-10 md:py-14 items-start"
            >
              <div className="md:col-span-1 font-body text-[10px] tracking-[0.32em] text-foreground/40">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="md:col-span-4">
                <h3
                  className="font-display leading-[1.05]"
                  style={{ fontSize: "clamp(1.6rem, 2.8vw, 2.5rem)", fontWeight: 400 }}
                >
                  {m.name}
                </h3>
                <p
                  className="mt-3 font-body text-[11px] uppercase"
                  style={{ color: "#3a7d7b", letterSpacing: "0.28em" }}
                >
                  {m.role}
                </p>
                <p
                  className="mt-2 font-body text-[11px]"
                  style={{ color: "hsl(var(--foreground) / 0.55)", letterSpacing: "0.08em" }}
                >
                  {m.creds}
                </p>
              </div>
              <div className="md:col-span-7 md:pt-3">
                <p
                  className="font-body text-base md:text-[16px] leading-[1.85]"
                  style={{ color: "hsl(var(--foreground) / 0.82)" }}
                >
                  {m.bio}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Team;
